module.exports = __webpack_public_path__ + "03_long_gold.efc00e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/03_long_gold.png
// module id = zhO1
// module chunks = 0